import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';

import * as actions from '../../Store/Actions';
import firebase from '../../Firebase/Firebase';
import {
  AuthBrand,
  AuthCard,
  AuthDescription,
  AuthFooter,
  AuthKicker,
  AuthLink,
  AuthNotice,
  AuthPage,
  AuthTitle,
} from '../../Components/Auth/AuthLayout';
import Button from '../../Components/UI/Forms/Button/Button';
import Message from '../../Components/UI/Messages/Message';

const Icon = styled.div`
  width: 4rem;
  height: 4rem;
  display: grid;
  place-items: center;
  margin-bottom: 1.25rem;
  border-radius: 1.2rem;
  color: var(--color-main);
  background: var(--color-mainLighter);

  svg {
    font-size: 2rem;
  }
`;

const Actions = styled.div`
  display: grid;
  gap: 0.75rem;
`;

const Email = styled.strong`
  color: #111;
  overflow-wrap: anywhere;
`;

const VerifyEmail = ({ cleanUp, email, error, loading, sendVerification }) => {
  const [checking, setChecking] = useState(false);
  const [checkMessage, setCheckMessage] = useState('');

  useEffect(() => {
    return cleanUp;
  }, [cleanUp]);

  const checkVerification = async () => {
    setChecking(true);
    setCheckMessage('');

    try {
      const user = firebase.auth().currentUser;
      if (!user) throw new Error('Votre session a expiré. Reconnectez-vous.');

      await user.reload();
      if (firebase.auth().currentUser?.emailVerified) {
        await firebase.auth().currentUser.getIdToken(true);
        window.location.assign('/');
        return;
      }

      setCheckMessage('L’adresse n’est pas encore validée. Ouvrez le lien reçu puis réessayez.');
    } catch (nextError) {
      setCheckMessage(nextError.message || 'La vérification n’a pas pu être actualisée.');
    } finally {
      setChecking(false);
    }
  };

  return (
    <AuthPage>
      <AuthCard>
        <AuthBrand subtitle="Sécurité du compte" />
        <Icon><MarkEmailReadOutlinedIcon /></Icon>
        <AuthKicker>Dernière étape</AuthKicker>
        <AuthTitle>Vérifiez votre adresse e-mail</AuthTitle>
        <AuthDescription>
          Un message de validation a été demandé pour <Email>{email || 'votre adresse e-mail'}</Email>. Cliquez sur le lien reçu pour activer votre espace.
        </AuthDescription>
        <AuthNotice>
          <strong>Vous ne voyez pas le message ?</strong>
          Vérifiez les courriers indésirables, patientez une minute, puis utilisez le bouton de renvoi. Votre compte reste enregistré pendant cette étape.
        </AuthNotice>
        <Actions>
          <Button loading={loading ? 'Envoi…' : null} onClick={sendVerification} type="button">
            Renvoyer l’e-mail de vérification
          </Button>
          <Button contain loading={checking ? 'Vérification…' : null} onClick={checkVerification} type="button">
            J’ai vérifié mon adresse
          </Button>
        </Actions>
        <Message error show={Boolean(error)}>{error}</Message>
        <Message success show={error === false}>Le message de vérification a été envoyé.</Message>
        <Message error show={Boolean(checkMessage)}>{checkMessage}</Message>
        <AuthFooter>
          Mauvaise adresse ? <AuthLink to="/logout">Se déconnecter</AuthLink>
        </AuthFooter>
      </AuthCard>
    </AuthPage>
  );
};

const mapStateToProps = ({ auth, firebase: firebaseState }) => ({
  email: firebaseState.auth?.email || '',
  loading: auth.verifyEmail.loading,
  error: auth.verifyEmail.error,
});
const mapDispatchToProps = { sendVerification: actions.verifyEmail, cleanUp: actions.cleanMessage };

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail);
